const alphabet = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z',
];

export const getColumnIndex = (columnLetter?: string | null): number | null => {
  if (!columnLetter || columnLetter.length === 0) {
    return 0;
  }
  if (columnLetter.length === 1 && alphabet.includes(columnLetter)) {
    // A, B, C, D, E...
    return alphabet.indexOf(columnLetter);
  }
  if (columnLetter.length === 2 && columnLetter.split('').every(letter => alphabet.includes(letter))) {
    // AA, AB, AC, AD, AE...
    const prefixIndex = alphabet.indexOf(columnLetter[0]);
    const suffixIndex = alphabet.indexOf(columnLetter[1]);
    if (prefixIndex !== -1 && suffixIndex !== -1) {
      return (prefixIndex + 1) * alphabet.length + suffixIndex;
    }
  }
  return null;
};

export const getColumnLetter = (columnIndex: number): string => {
  if (columnIndex > alphabet.length - 1) {
    const prefix = Math.trunc(columnIndex / alphabet.length) - 1;
    const suffix = columnIndex % alphabet.length;
    return `${alphabet[prefix]}${alphabet[suffix]}`;
  }

  return alphabet[columnIndex];
};

export const alphabetGenerator = (columns: string[] = [], totalColumns = 0): string[] => {
  const newAlphabet: string[] = [];
  const generator = (index: number) => {
    const letter = getColumnLetter(index);
    newAlphabet.push(letter);
  };

  if (totalColumns > 0) {
    for (let i = 0; i < totalColumns; i += 1) {
      generator(i);
    }
  } else if (columns && columns.length > 0) {
    for (let columnIndex = 0; columnIndex < columns.length; columnIndex += 1) {
      generator(columnIndex);
    }
  }

  return newAlphabet;
};

export const getLastColumn = (totalColumns: number): string => {
  const generatedAlphabet = alphabetGenerator([], totalColumns);
  return generatedAlphabet[generatedAlphabet.length - 1];
};
